import { render } from "./money_from_bugalter.vue?vue&type=template&id=fe0d45c8&scoped=true"
import script from "./money_from_bugalter.vue?vue&type=script&lang=js"
export * from "./money_from_bugalter.vue?vue&type=script&lang=js"

import "./money_from_bugalter.vue?vue&type=style&index=0&id=fe0d45c8&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0d45c8"]])

export default __exports__